import { useEffect, useState } from "react";
import { useNavigationType } from "react-router-dom";

// useState that survives leaving a page and coming Back to it.
//
// The value is saved to sessionStorage on every change. It is only restored
// when the page is reached by going Back/Forward (history "POP") or reloaded —
// a fresh visit (sidebar link, dashboard card, button) starts from `initial`,
// so a dashboard drill-down still opens on the card's own filters.
//
// `serialize` / `deserialize` handle values JSON can't carry (e.g. dayjs).
export const usePersistedState = (key, initial, { serialize, deserialize } = {}) => {
  const navigationType = useNavigationType();
  const storageKey = `lmggt:${key}`;

  const [value, setValue] = useState(() => {
    if (navigationType === "POP") {
      try {
        const raw = sessionStorage.getItem(storageKey);
        if (raw !== null) {
          const parsed = JSON.parse(raw);
          return deserialize ? deserialize(parsed) : parsed;
        }
      } catch (e) {
        // fall through to the default
      }
    }
    return typeof initial === "function" ? initial() : initial;
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify(serialize ? serialize(value) : value)
      );
    } catch (e) {
      // storage unavailable (private window / quota) — just don't persist
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageKey, value]);

  return [value, setValue];
};

export default usePersistedState;
